function ChatList({ chats, loading, onSelectChat, baseUrl, selectedChat }) {
  const getAvatar = (chat) =>
    chat?.profile_pic ? `${baseUrl}${chat.profile_pic}` : 
    chat?.profile_image ? `${baseUrl}${chat.profile_image}` : 
    "images/user_dh.png";

  const formatTime = (ts) => {
    if (!ts) return "";
    const d = new Date(ts);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  return (
    <div className="listing_area">
      <div className="mn_top_area">
        <h3>Messages ({Array.isArray(chats) ? chats.length : 0})</h3>
      </div>

      <div className="listing_mains">
        {loading && <p>Loading chats...</p>}

        {!loading && (!Array.isArray(chats) || chats.length === 0) && (
          <p className="nodata">No chats found</p>
        )}

        {Array.isArray(chats) &&
          chats.map((chat) => {
            const isActive =
              selectedChat &&
              Number(selectedChat?.user_id) === Number(chat?.user_id);

            return (
              <div
                key={chat.user_id ?? `${chat.first_name}-${chat.email}`}
                className={`un_litingss ${isActive ? "active" : ""}`}
                onClick={() => onSelectChat(chat)}
                style={{ cursor: "pointer" }}
              >
                <div className="usr_mgs">
                  <img
                    src={getAvatar(chat)}
                    alt={`${chat.first_name || ""} ${chat.last_name || ""}`}
                    onError={(e) => (e.currentTarget.src = "images/user_dh.png")}
                  />
                </div>

                <div className="tx_contents">
                  <h4>
                    {(chat.first_name || "") + " " + (chat.last_name || "")}
                    <span className="tms">{formatTime(chat.last_message_time)}</span>
                  </h4>
                  <p>
                    <span className="diss_tx">{chat.last_message || ""}</span>
                    {chat.unread_count > 0 && (
                      <span className="usr_counts">{chat.unread_count}</span>
                    )}
                  </p>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default ChatList;

